"use strict";
var _a;
Object.defineProperty(exports, "__esModule", { value: true });
exports.CenteredMessage = void 0;
var i18n_1 = require("../i18n");
var mithril_1 = require("../mithril");
var theme_1 = require("./theme");
var CSS = {
    container: 'c-CenteredMessage'
};
var Style = (_a = {},
    _a[CSS.container] = {
        height: '100%',
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        textAlign: 'center'
    },
    _a);
(0, theme_1.addStyles)(Style);
exports.CenteredMessage = {
    view: function (message) {
        return (0, mithril_1.m)('div', { className: CSS.container }, (0, i18n_1.Translate)(message));
    }
};
//# sourceMappingURL=centeredMessage.js.map